import React from "react";
import FormDialog from "../../../shared/FormDialog";
import TicketButtonSet from "./TicketButtonSet";
import { Assort } from "../../../models/Assort";
import { Grid } from "@material-ui/core";

interface IProps {
  open: boolean;
  onSelectTicket: (assort: Assort) => void;
  ticketList: Assort[];
  onClose: () => void;
}

const TicketsSeatModal: React.FC<IProps> = ({ open, ticketList, onSelectTicket, onClose }: IProps) => {
  return (
    <FormDialog open={open} onClose={onClose} title={"Wybierz bilet"} hideActions>
      <Grid container>
        <Grid item xs={12}>
          {ticketList.map((ticket, index) => (
            <TicketButtonSet ticket={ticket} onBtnClick={onSelectTicket} key={index} isSelected={false} />
          ))}
        </Grid>
      </Grid>
    </FormDialog>
  );
};

export default TicketsSeatModal;
